import { computed } from 'vue'

import useAuthStore from '@/store/auth.store'

export default function useViewer() {
  const auth = useAuthStore()
  const viewer = computed(() => auth.user)
  return { viewer }
}
